import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-home-resolve',
  templateUrl: './home-resolve.component.html',
  styleUrls: ['./home-resolve.component.css']
})
export class HomeResolveComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
